import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { GlobalState } from 'ha/types/store';
import { getCurrentPageLanguages } from 'ha/modules/LanguageSwitcher/selectors';

import { OwnProps, Footer } from '../components/Footer';

const FooterContainer: React.FC<
  Omit<OwnProps, 'availableLanguages'>
> = props => {
  const location = useLocation();

  const getLanguages = React.useCallback(
    (state: GlobalState) => getCurrentPageLanguages(state, location),
    [location],
  );
  const availableLanguages = useSelector(getLanguages);

  return <Footer {...props} availableLanguages={availableLanguages} />;
};

export { FooterContainer };
